export default __webpack_public_path__ + "static/media/hurricane.ab7cdcf4.svg";